export const fetchOption = async (geoserverUrl, layerName, variableName, option) => {

    if (option !== '') {
    const url = `${geoserverUrl}?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&propertyName=${variableName}&CQL_FILTER=dpa_descan%20LIKE%20%27${option}%27`;
    const response = await fetch(url);
    const data = await response.json();
    const variable = data.features[0].properties[variableName];
    return(variable);
    }
    else {
        return ''
    }
  };